module.exports = __webpack_public_path__ + "static/circleamarillo-efea1c852f55a59234b35e50f45c6fea.png";